import React, { useCallback, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';
import { Container, Info, Cards } from './styles';
import Header from '../../components/Header';
import NavBar from '../../components/NavBar';
import Button from '../../components/Button';

const Relatorios: React.FC = () => {
  const [pesquisa, setPesquisa] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  const history = useHistory();

  const relatorios = [
    { id: 0, nome: 'CAIXAS' },
    { id: 1, nome: 'VENDAS' },
    { id: 2, nome: 'CANCELAMENTOS' },
    { id: 3, nome: 'VENDAS POR PRODUTO' },
    // { id: 4, nome: 'VENDAS POR TURNO' },
    // { id: 3, nome: 'QUARTO RELATORIO' },
  ];

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
  }, []);

  const handlePesquisa = useCallback((e) => {
    console.log(e.target.value);
    setPesquisa(e.target.value);
  }, []);

  const handleClick = useCallback(
    (id) => {
      console.log(id);
      localStorage.setItem('@MeuPantera:idRelatorio', id);
      history.push('/relatorio');
    },
    [history],
  );

  return (
    <Container>
      <NavBar />
      <div id="page-wrap">
        <Header />
        <Info isFocused={isFocused}>
          <h1>Relatórios</h1>
          <br />
          <div className="inputDiv">
            <FiSearch />
            <input
              onFocus={handleInputFocus}
              onBlur={handleInputBlur}
              placeholder="Pesquisar"
              onChange={handlePesquisa}
            />
          </div>
          <Cards>
            {relatorios
              .filter((relatorio) =>
                relatorio.nome.toUpperCase().includes(pesquisa.toUpperCase()),
              )
              .map((filtered) => (
                <Button onClick={() => handleClick(filtered.id)}>
                  {filtered.nome}
                </Button>
              ))}
          </Cards>
        </Info>
      </div>
    </Container>
  );
};

export default Relatorios;
